interface DividerProps {
  m?: boolean;
  orientation?: "horizontal" | "vertical";
}

function Divider({ m, orientation = "horizontal" }: DividerProps) {
  return (
    <div
      className={`
          ${orientation === "vertical" ? "h-full w-[1px]" : "h-[1px] w-full"}
          ${m ? "my-5" : "m-0"}
          bg-border
        `}
    />
  );
}

export default Divider;
